// Imports
import Layout from '@/components/layout/Layout'
import { GLOBAL_CONSTANTS } from '@/constants/globalConstants'

export function MTInsight() {
  // Return
  return (
    <Layout>
      <div className="p-4">
        <h1 className="text-[var(--font-size-xl)] font-[var(--heading-font-weight)] text-[var(--forbrand-primary)]">
          {GLOBAL_CONSTANTS.MT_INSIGHT_TITLE}
        </h1>
        <p className="text-[var(--font-size-sm)] text-[var(--forbrand-secondary)] mt-2">
          {GLOBAL_CONSTANTS.MT_INSIGHT_DESCRIPTION}
        </p>
      </div>
    </Layout>
  )
}
